import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { withTranslation } from 'react-i18next';
class PrivateRoute extends Component {
  constructor(props) {
    super(props);
  }


  render() {
    const { component: Component, ...rest } = this.props;
    return (
      <div>

        <Route
          {...rest}
          component={(props) =>
            this.props.isAuthenticated ? (
              <div className="h-100">
                <Component {...props} />
              </div>
            ) : (
              <Redirect to="/" />
            )
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,

});

export default connect(mapStateToProps)(PrivateRoute);
